import { themeAtom } from "../atoms";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

type Props = {
  data: Record<string, unknown>;
};

const ReadOnlyForm = ({ data }: Props) => {
  const theme = useAtomValue(themeAtom);

  return (
    <div className="grid grid-cols-5 gap-4">
      {Object.entries(data).map(([label, value], index) => (
        <div key={index} className="py-2">
          <div className={twMerge("text-custom-label text-xs font-normal", theme.vesselDetails.fields)}>{label}</div>
          <div className={twMerge("text-custom-value text-sm font-normal", theme.vesselDetails.info)}>
            {String(value)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReadOnlyForm;
